import { getPortalData } from 'services/portalData';

/**
 * Tenant-aware term dictionary — one day it may be replaced by a real i18n lib.
 *
 * i18n                      .staffTitle = 'Concierge' (tenant-configured)
 * i18n.plural               .staffTitle = 'Concierges'
 * i18n.withIndefiniteArticle.staffTitle = 'a Concierge'
 *
 * staffTitle is what patients see the tenant's admin/support staff called —
 * self-serve via Tenant Options, delivered through portal-data, with a
 * product default when unset. Never hardcode "Concierge" in components.
 */
const DEFAULT_STAFF_TITLE = 'Staff Member';

const i18nTable = {
  get staffTitle(): string {
    return getPortalData()?.staff_title || DEFAULT_STAFF_TITLE;
  },
};

const transformations = {
  plural: (value: string) => `${value}s`,
  withIndefiniteArticle: (value: string) => `${indefiniteArticleOf(value)} ${value}`,
};

type I18n = typeof i18nTable & {
  [K in keyof typeof transformations]: typeof i18nTable;
};

// extends i18nTable with new functions, ie.
// i18n.withIndefiniteArticle.staffTitle = 'a Concierge'

const i18n = new Proxy(i18nTable, {
  get(target, prop, receiver) {
    const tranformation = transformations[prop as keyof typeof transformations];
    if (tranformation) {
      return makeTransformerProxy(i18nTable, tranformation);
    }
    //@ts-ignore
    return Reflect.get(...arguments);
  },
}) as I18n;

function makeTransformerProxy(value: any, callback: (val: string) => string) {
  return new Proxy(value, {
    get() {
      //@ts-ignore
      return callback(Reflect.get(...arguments));
    },
  });
}

function indefiniteArticleOf(s: string) {
  // First letter decides the article ("an Admin", "a Concierge").
  return /^[aeiou]/i.test(s) ? 'an' : 'a';
}

export default i18n;
